// import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import MyCvLoader from "./MyCvLoader";
import { searchMember, uploadCV } from "../../../api/apiServices";
import { useMutation } from "react-query";
import Swal from "sweetalert2";
import PhoneInput from "react-phone-input-2";

export const UploadMemberCV = () => {
	const navigate = useNavigate();

	const [search, setSearch] = useState(false);
	const [searchParams, setSearchParams] = useState({
		pf_number: "",
		mobile_number: "",
		email: "",
	});

	const [data, setData] = useState({
		pf_number: "",
		fullname: "",
		mobile_number: "",
		email: "",
		profession: "",
		selectedFile: null,
		previewUrl: "",
	});

	useEffect(() => {
		data.selectedFile &&
			setData((prevData) => ({
				...prevData,
				previewUrl: URL.createObjectURL(data.selectedFile),
			}));
	}, [data.selectedFile]);

	const handleChange = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		setSearchParams((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleMobileNumber = (value, countryObj, e, formattedValue) => {
		const name = e.target.name;
		let mobileNumber = value.replaceAll(" ", "");

		if (mobileNumber.substring(4, 0) === "2330") {
			mobileNumber = mobileNumber.replace("0", "");
		}
		setSearchParams((prevData) => ({
			...prevData,
			[name]: mobileNumber.replaceAll(" ", ""),
		}));
	};

	const handleSearch = async (e) => {
		e.preventDefault();

		const searchData = {
			pf_number: searchParams.pf_number,
			mobile_number: searchParams.mobile_number,
			email: searchParams.email,
		};
		searchMutation.mutate(searchData);
	};

	const searchMutation = useMutation(searchMember, {
		onSuccess: async (res) => {
			console.log(res);
			setSearch(true);
			setData((prevData) => ({
				...prevData,
				pf_number: res[0].pf_number,
				fullname:
					res[0].first_name +
					" " +
					res[0].middle_name +
					" " +
					res[0].last_name,
				mobile_number: res[0].mobile_number,
				email: res[0].email,
				profession: res[0].profession,
			}));
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
			setSearch(false);
			return false;
		},
	});

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!data.selectedFile) {
			Swal.fire({
				title: "Oooops!",
				text: "Please upload your new CV or Cancel!",
				icon: "warning",
				width: 400,
				padding: "3em",
			}).then((result) => {
				if (result.isConfirmed) {
					return false;
				}
			});
		} else {
			let formData = new FormData();

			formData.append("file", data.selectedFile);
			formData.set("pf_number", data.pf_number);
			formData.set("fullname", data.fullname);
			formData.set("mobile_number", data.mobile_number);
			formData.set("email", data.email);
			formData.set("profession", data.profession);
			createCVMutation.mutate(formData);
		}
	};

	const createCVMutation = useMutation(uploadCV, {
		onSuccess: async (res) => {
			if (!res.success) {
				toast.error(res.message, {
					duration: 5000,
					className: "toast-message",
				});
			} else {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
		},
	});

	const handleCancel = () => {
		setSearch(false);
	};

	let searchContent = (
		<>
			<form onSubmit={handleSearch}>
				<div className="form-group row">
					<fieldset className="col-sm-12">
						<div className="col-sm-3">
							<input
								type="text"
								style={{
									textTransform: "uppercase",
									height: "40px",
									borderRadius: "5px",
								}}
								placeholder="PF Number"
								onChange={handleChange}
								value={searchParams.pf_number}
								name="pf_number"
								className="form-control"
							/>
						</div>
						<div className="col-sm-3">
							<PhoneInput
								id="mobile_number"
								inputStyle={{
									paddingTop: 16,
									paddingRight: 14,
									paddingBottom: 15,
									paddingLeft: 58,
									fontSize: 18,
									width: "100%",
									zIndex: 1,
									height: 40,
									color: "gray",
									backgroundColor: "#F3F6F9",
								}}
								country={"gh"}
								countryCodeEditable={false}
								enableSearch={true}
								enableClickOutside={false}
								disableDropdown={false}
								value={searchParams.mobile_number}
								inputProps={{
									name: "mobile_number",
									required: true,
									autoFocus: false,
								}}
								onChange={(
									value,
									countryObj,
									e,
									formattedValue
								) =>
									handleMobileNumber(
										value,
										countryObj,
										e,
										formattedValue
									)
								}
							/>
						</div>
						<div className="col-sm-3">
							<input
								type="email"
								placeholder="Email"
								onChange={handleChange}
								value={searchParams.email}
								name="email"
								className="form-control"
							/>
						</div>
						<div className="col-sm-3">
							<button
								type="submit"
								className="btn btn-success btn-block"
							>
								{" "}
								<i className="fa fa-search"></i> Search Member
							</button>
						</div>
					</fieldset>
				</div>
			</form>
		</>
	);

	const myCv = (
		<>
			<form onSubmit={handleSubmit}>
				<fieldset className="col-sm-6">
					<legend>PERSONAL INFORMATION </legend>
					<label
						htmlFor="payment_mode"
						className="col-sm-4 col-form-label"
					>
						PF Number<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							id="pf_number"
							disabled
							value={data.pf_number}
							className="form-control"
						/>
					</div>
					<label
						htmlFor="payment_mode"
						className="col-sm-4 col-form-label"
					>
						Full Name<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							id="pf_number"
							disabled
							value={data.fullname}
							className="form-control"
						/>
					</div>
					<label
						htmlFor="payment_mode"
						className="col-sm-4 col-form-label"
					>
						Phone Number<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							id="pf_number"
							disabled
							value={data.mobile_number}
							className="form-control"
						/>
					</div>
					<label
						htmlFor="payment_mode"
						className="col-sm-4 col-form-label"
					>
						Email Address<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							id="pf_number"
							disabled
							value={data.email}
							maxLength={1000}
							// cols="10"
							rows="5"
							className="form-control"
						/>
					</div>
					<label htmlFor="profession" className="col-sm-4 label-text">
						Profession<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<textarea
							type="text"
							id="profession"
							disabled
							value={data.profession}
							className="form-control"
						/>
					</div>
				</fieldset>
				<fieldset className="col-sm-6">
					<legend>UPLOAD CV </legend>
					<label htmlFor="photo" className="col-sm-4 label-text">
						Curriculum Vitae<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<MyCvLoader
							name={"selectedFile"}
							data={data}
							setData={setData}
						/>
					</div>
					{data.previewUrl && (
						<>
							<label
								htmlFor="filename"
								className="col-sm-4 label-text"
							>
								File Name<span>&nbsp;&nbsp;*</span>
							</label>
							<div className="col-sm-8">
								<span
									style={{
										fontSize: "14px",
										fontWeight: "bold",
										color: "blue",
										cursor: "pointer",
									}}
								>
									{" "}
									{data.selectedFile.name}{" "}
								</span>
							</div>
						</>
					)}
				</fieldset>

				<fieldset className="col-sm-12">
					<div className="panel-footer">
						<div className="row">
							<div className="col-sm-2">
								<button
									type="submit"
									className="btn btn-success btn-block"
								>
									Submit
								</button>
								&nbsp;&nbsp;&nbsp;&nbsp;
							</div>
							<div className="col-sm-2">
								<button
									type="button"
									onClick={handleCancel}
									className="btn btn-danger btn-block"
								>
									Cancel
								</button>
							</div>
						</div>
					</div>
				</fieldset>
			</form>
		</>
	);

	return (
		<>
			<Toaster toastOptions={{ position: "top-center" }} />
			<section className="content-header">
				<h1>
					<i className="fas file"></i> Curriculum Vitae
				</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>{searchContent}</span>
										</h4>
									</div>
								</div>
							</div>
							{search && <div className="panel-body">{myCv}</div>}
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
